import { AnimatePresence, motion } from 'framer-motion'
import { useUI } from '../../context/UIContext'
import DonationForm from './DonationForm'

const DonationModal = () => {
  const { isModalOpen, closeModal, isVerifying, donationSuccess } = useUI()

  const canClose = !isVerifying || donationSuccess

  const panelClass = donationSuccess
    ? "fixed inset-x-4 top-1/2 -translate-y-1/2 sm:inset-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:w-full sm:max-w-[900px] z-50 bg-white rounded-3xl shadow-2xl max-h-[90vh] overflow-y-auto"
    : "fixed inset-x-2 top-4 bottom-4 sm:inset-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:w-full sm:max-w-[900px] z-50 bg-white rounded-3xl shadow-2xl overflow-y-auto"

  return (
    <AnimatePresence>
      {isModalOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            key="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
            onClick={canClose ? closeModal : undefined}
          />

          {/* Modal panel */}
          <motion.div
            key="modal"
            initial={{ opacity: 0, y: 60, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 40, scale: 0.96 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className={panelClass}
            dir="rtl"
          >
            {/* Modal header */}
            <div className="absolute top-4 left-4 z-20">
              {canClose && (
                <button
                  onClick={closeModal}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-[#6b7280] transition-colors cursor-pointer"
                  aria-label="סגירה"
                >
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>

            {/* Modal body */}
            <div className="px-6 py-8 sm:py-12 sm:px-10">
              <DonationForm />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default DonationModal
